import React from "react"
import { useHistory } from "react-router-dom"

export default function RegistryCard({
  header_image,
  registry_name,
  start_date,
  registry_slug
}) {
  const startDate = new Date(start_date).toDateString()

  const history = useHistory()

  return (
    <div className="mobiles:w-1/2 tablets:w-1/3 w-1/4 p-2">
      <div className="registry-card shadow rounded-lg h-80">
        <img
          className="w-full rounded-t-lg h-4/6 object-cover"
          src={header_image}
          alt="event"
        />
        <div className="info p-3 font-thin">
          <div className="event-name">{registry_name}</div>
          <div className="flex justify-between font-thin text-xs">
            <p style={{ marginTop: "auto", marginBottom: "auto" }}>
              {startDate}
            </p>
            <button
              className="view-btn px-2 py-1 rounded-md font-thin text-xs text-white"
              style={{ background: "#6F64F8" }}
              onClick={() => {
                history.push(`/gift/registry/${registry_slug}`)
              }}
            >
              View
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
